import { useState, useEffect } from "react";
import { ReactTableDataGrid } from "components/Table";
import ReactImageMagnify from "react-image-magnify";
import { Link } from "react-router-dom";

const limit = 10;
const TableProduct = ({ data, tableName = "" }) => {
    const [list, setList] = useState([]);

    useEffect(() => {
        if (data) {
            setList(data?.slice(0, limit));
        }
    }, [data]);

    const columns = [
        {
            field: "_id",
            width: 40,
            cellClass: "centered-cell",
            headerName: "",
            cellRenderer: ({ rowIndex, value: cell, data: row }) => rowIndex + 1,
            sortable: false,
        },
        {
            field: "product_name",
            headerName: "Image",
            sortable: false,
            editable: false,
            flex: 1,
            cellClass: "overflow-visible",
            cellRenderer: ({ data: row, cell }) => (
                <Link to={row.images} target="_blank">
                    <ReactImageMagnify
                        {...{
                            smallImage: { alt: "VIEW", width: 60, height: 60, src: row.images || "" },
                            largeImage: { src: row.images, width: 600, height: 600 },
                            enlargedImageContainerDimensions: { width: "600%", height: "600%" },
                            enlargedImageContainerStyle: { zIndex: 99 },
                            imageClassName: "overflow-hidden",
                        }}
                    />
                </Link>

            ),
        },
        {
            field: "name",
            headerName: "Name",
            sortable: false,
            flex: 1,
        },
        {
            field: "count",
            headerName: "Total",
            cellRenderer: ({ rowIndex, value: cell, data: row }) => row.count,
            sortable: false,
            flex: 1,
        },
    ];

    const onTableChanged = ({ page }) => {
        const startIndex = (page - 1) * limit;
        setList(data.slice(startIndex, startIndex + limit));
    };

    return (
        <ReactTableDataGrid
            idProperty="_id"
            tableName={tableName}
            columns={columns}
            height={350}
            rowData={list}
            gridOptions={{
                rowHeight: 80,
                reactiveCustomComponents: true,
            }}
            paginationPageSize={limit}
            totalSize={data?.length || 0}
            emptyText={"No data!"}
            rowSelection="multiple"
            onTableChanged={onTableChanged}
            isSearchText={false}
        />
    );
};

export default TableProduct;
